<template>
    <div class="u-padding u-text-align-center u-font-medium">
        <slot name="title"></slot>
        <br>
        <p class="u-font-default"><slot name="sub-title"></slot></p>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        props: {},
        components: {},
        data() {
            return {}
        },
        methods: {},
    }
</script>

<style lang="scss">

    @import "~@/assets/scss/private";

</style>


// WEBPACK FOOTER //
// src/components/EmptyState.vue